module.exports = __webpack_public_path__ + "static/img/认证4.5073476b.jpg";